<template>
  <div class="vacature">
    <page>
      <template v-slot:header>Vacature hoofdanimator</template>

      <block blockTitle="Vacature hoofdanimator speelplein De Speelberg" :class="'no-flex'">
        <p>
          Voor onze speelpleinwerking met open speelaanbod (voor kinderen van 3 tot 15 jaar) te
          Beveren-Leie zijn wij op zoek naar hoofdanimatoren om onze dagelijkse werking en
          vrijwilligers te ondersteunen tijdens de zomermaanden.
        </p>
      </block>

      <block blockTitle="Jobinhoud" :class="'no-flex'">
        <ul>
          <li>Je coacht een team vrijwilligers/animatoren bij het organiseren van een breed speelaanbod.</li>
          <li>Je communiceert met ouders en de leidingsploeg.</li>
          <li>Je plant de speelpleindag en leidt deze in goede banen.</li>
          <li>Je vervult een pakket aan administratieve taken, zodat de leiding zich volop kan focussen op het animeren.</li>
          <li>Je geeft zelf activiteiten wanneer dit nodig is.</li>
          <li>Je bewaakt en stimuleert de sfeer in de ploeg.</li>
        </ul>
      </block>

      <block blockTitle="Wat verwachten we van jou?" :class="'no-flex'">
        <ul>
          <li>18 jaar of ouder.</li>
          <li>Animator en/of hoofdanimator attest (of gelijkwaardig door ervaring).</li>
          <li>Ervaring in het jeugdwerk.</li>
          <li>Verantwoordelijkheidszin & organisatorisch inzicht.</li>
          <li>Motivatie om een jonge multiculturele ploeg vrijwilligers te coachen en mee te trekken in je enthousiasme.</li>
          <li>Je bent beschikbaar van 17 tot en met 28 augustus 2026.</li>
          <li>Je kan om met een flexibel uurrooster (geen nine-to-five).</li>
          <li>Een rijbewijs is een pluspunt.</li>
        </ul>
      </block>

      <block blockTitle="Wat kan je van ons verwachten?" :class="'no-flex'">
        <ul>
          <li>Correcte verloning (14,5 euro per uur) via Stad Waregem.</li>
          <li>Ondersteuning bij je takenpakket door een tweede hoofdanimator en de stuurgroep.</li>
          <li>Je komt terecht in een gemotiveerde vriendengroep van vrijwilligers.</li>
          <li>Een leuke vakantiejob met veel vrijheid en inspraak, waar je echt iets kan betekenen voor het jeugdwerk.</li>
        </ul>
      </block>

      <block blockTitle="Hoe solliciteren?" :class="'no-flex'">
        <p>
          Stuur je CV en motivatiebrief door naar
          <a class="link" href="mailto:info@despeelberg.be">info@despeelberg.be</a>
          tegen ten laatste 1 augustus 2026. Nadien plannen we een persoonlijk sollicitatiegesprek in.
        </p>
      </block>
    </page>
  </div>
</template>

<script>
import Page from '../components/Page'
import Block from '../components/Block'
export default {
  components: {
    Page,
    Block
  }
}
</script>

<style>
.vacature {
  height: inherit;
  min-height: inherit;
}

.vacature ul {
  font-family: 'Roboto', Arial, Helvetica, sans-serif;
  font-size: 18px;
  color: grey;
  margin: 10px 0;
  padding-left: 20px;
}

.vacature li {
  margin: 5px 0;
}
</style>
